(function () {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  if (window.__ukb4cSearchFieldsFixApplied) return;
  window.__ukb4cSearchFieldsFixApplied = true;

  var FIELDS = 'title,vendor,product_type,variants.title,variants.sku,variants.barcode';
  var SUGGEST_RE = /\/search\/suggest(?:\.json)?(?:[\?#]|$)/i;
  var ALREADY_RE = /resources\[options\]\[fields\]=/i;

  function rewrite(urlStr) {
    if (!urlStr || !SUGGEST_RE.test(urlStr) || ALREADY_RE.test(urlStr)) return urlStr;
    var sep = urlStr.indexOf('?') !== -1 ? '&' : '?';
    return urlStr + sep + 'resources[options][fields]=' + encodeURIComponent(FIELDS);
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = rewrite(input);
      } else if (input && typeof input.url === 'string' && SUGGEST_RE.test(input.url) && !ALREADY_RE.test(input.url)) {
        input = new Request(rewrite(input.url), input);
      }
    } catch (e) { /* fall through with original input */ }
    return origFetch.apply(this, arguments);
  };
})();
